<template>
  <div class="card mb-3 card-radius" :class="{ borderActive: cardBorder }">
    <div class="d-flex justify-content-between mb-2">
      <img :src="job.company_image" class="card-img" />
      <div class="text-muted cs-textstyle-paragraph-small pr-2">
        {{ job.created_at | moment("from") }}
      </div>
    </div>
    <div class="row no-gutters mb-4">
      <!-- <div class=""> -->
      <div class="card-body">
        <h5 class="cs-texstyle-item-heading">{{ job.name }}</h5>
        <p class="card-company cs-texstyle-paragraph">
          {{ job.company_name }}
        </p>
        <p class="cs-texstyle-paragraph-small">
          <small class="text-muted" v-if="job.location">{{
            job.location
          }}</small>
          <small class="text-muted" v-else>Remote Position</small>
        </p>
      </div>
      <!-- </div> -->
    </div>
    <div class="card-button">
      <cs-button
        variant="primary"
        corners="rounded"
        :to="{ name: 'JobDetail', params: { id: job.id } }"
        >Learn More</cs-button
      >
    </div>
  </div>
</template>

<script>
export default {
  props: {
    job: {
      type: Object,
      required: true,
    },
    cardBorder: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.card {
  height: 16rem;
  padding: 15px 5px !important;
  margin: 5px 0px !important;
}
.card-company {
  margin-top: 5px;
  margin-bottom: 0px;
}
.card-radius {
  border-radius: 10px;
}
.card-button {
  position: absolute;
  bottom: 10px;
  margin-left: 10px;
}
a:not([href]):hover {
  color: white;
}
img {
  width: 45px;
  height: 45px;
  margin-left: 10px;
}
.borderActive {
  border: 1px solid var(--cs-gray-02);
}
</style>>
